import { render, staticRenderFns } from "./InputPromo.vue?vue&type=template&id=7fc88c22&"
import script from "./InputPromo.vue?vue&type=script&lang=js&"
export * from "./InputPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports